import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import merge from 'lodash/merge'
import { refreshtoken } from './qingqiu'
import { setToken } from '../../store/actions'
import { token } from '../../store/getters' 
import Cookies from 'js-cookie'
import {axiosTimer} from '../../io/axiosTimer.js'
// baseUrl
// axios.defaults.baseURL = "http://47.93.3.212";
//郑本地接口地址
axios.defaults.baseURL = "/chuan-cheng-test"
// axios.defaults.baseURL = "https://1ee7889148.goho.co/chuan-cheng"
// axios.defaults.baseURL = "http://178891yg48.iask.in:55324"

/*是否有请求正在刷新token*/
window.isRefreshing = false
/*被挂起的请求数组*/
let refreshSubscribers = []

/*push所有请求到数组中*/
function subscribeTokenRefresh (cb) {
  	refreshSubscribers.push(cb)
}

/*刷新请求（refreshSubscribers数组中的请求得到新的token之后会自执行，用新的token去请求数据）*/
function onRrefreshed (token) {
  	refreshSubscribers.map(cb => cb(token))
}

/*请求拦截器*/ 
axios.interceptors.request.use(function (config) {
	let token =  localStorage.getItem('token') || (Cookies.get("token")?Cookies.get("token"):'');
	let refreshToken=window.localStorage.getItem("refresh_token")||''; 
	console.log(token ,'=====axios.config')
	if(token){ 
		config.headers["Authorization"] = 'bearer' +token ; 
		if(refreshToken){
			axiosTimer(refreshToken)
		}
	} 
	let $loadingBox = document.querySelector('.loading-box');
	$loadingBox && ($loadingBox.style.display = 'flex');
	return config;
}, function (error) {
	return Promise.reject(error);
}); 
	


// axios.interceptors.request.use(config => {
//     // 获取token
//     const token = localStorage.getItem('token');
//     const token_type = localStorage.getItem('token_type');
//     if (token) {
//         config.headers['Authorization'] = `${token_type} ${token}`
//         //判断是否过期
//         //现在的时间戳
//         var nowrefreshFlag = new Date().getTime();
//         //拿到域里的时间
//         debugger
//         var refreshFlag = localStorage.getItem('expir');
//         if (!refreshFlag == 0) {
//             if (nowrefreshFlag > refreshFlag) {
//                 window.isRefreshing = true;
//                 localStorage.removeItem("token");
//                 const refreshToken = localStorage.getItem('refresh_token');
//                 //刷新token
//                 let res2 = axios({
//                     url: '/refreshToken?refreshToken='+refreshToken , // 假地址 自行替换
//                     method: 'get'
//                 })
//                 console.log("res=============>>", res2)
//                 if(res2.code == 200){
//                     token = res2.data.access_token
//                     var refresh_token = res2.data.refresh_token
//                     token_type = res2.data.token_type
//                     var expir = res2.data.expires_in * 1000 / 2 + new Date().getTime();
//                     window.localStorage.setItem("token", token);
//                     window.localStorage.setItem("token_type", token_type);
//                     window.localStorage.setItem("refresh_token", refresh_token);
//                     window.localStorage.setItem("expir", expir);
//                     config.headers['Authorization'] = `${token_type} ${token}`
//                     //重新发起请求
//                     request.forEach((item) => {
//                         item.resolved(token);
//                     });
//                     // 清空缓存池
//                     request = [];
//                     window.isRefreshing = false;
//                     // 重点
//                     const externalControl = {
//                         resolved: null,
//                     };
//                     // 这里返回了一个新的Promise变相的实现请求的挂起（只要没有resolved或rejected，请求就会一直处于pedding状态）
//                     // 并将Promise状态的改变放到了外部一个对象来控制 externalControl ，待定池缓存这个对象即可，待需要执行后续被拦截请求，只需要利用这个对象引用的 resolved 来改变Promise状态即可实现请求挂起的放行
//                     const interceptPromise = new Promise((resolved) => {
//                         externalControl.resolved = resolved;
//                     });
//                     request.push(externalControl);
//                     return interceptPromise;
//                 }
//             }
//         }
//     }
//     return config
// }, error => {
//     console.log(error)
// })


//重试队列，每一项将是一个待执行的函数形式
let request = []

axios.interceptors.response.use(res => {
    // if (res.data.code === 0) {
    //     const config = res.config;
    //     //现在的时间戳
    //     var nowrefreshFlag = new Date().getTime();
    //     //拿到域里的时间
    //     var refreshFlag = localStorage.getItem('expir');
    //     if (!refreshFlag == 0) {
    //         if (nowrefreshFlag > refreshFlag) {
    //             const refreshToken = localStorage.getItem('refresh_token');
    //             //刷新token
    //             let res2 = axios({
    //                 url: '/refreshToken?refreshToken='+refreshToken , // 假地址 自行替换
    //                 method: 'get'
    //               }).then((res) => {
    //                 return Promise.resolve(res)
    //               })
    //             console.log("res=============>>", res2)
    //             var token = res2.data.access_token
    //             var refresh_token = res2.data.refresh_token
    //             var token_type = res2.data.token_type
    //             var expir = res2.data.expires_in * 1000 / 2 + new Date().getTime();
    //             window.localStorage.setItem("token", token);
    //             window.localStorage.setItem("token_type", token_type);
    //             window.localStorage.setItem("refresh_token", refresh_token);
    //             window.localStorage.setItem("expir", expir);
    //             return res;
    //         }
    //     }
    // }
    return res;
}, err => {
    console.log(err)
    return Promise.reject(error)
})

//     if(token){}
//     const token = localStorage.getItem('token');
//     const refresh_token  = localStorage.getItem('refresh_token');
//     const token_type = localStorage.getItem('token_type');
//     if (token) {
//         config.headers.common['Authorization'] = `${token_type}?${token}`;
//     }
//     config.headers.common['deviceId'] = 'deviceId123456789';

//     return config
//  }, function (error) {
//         // 对请求错误做些什么
//         return error
// });

/**
 * 设置拦截器，interceptors 响应处理
 * 所有使用 axios 的请求响应，都会优先回调到拦截器中
 * 在正确的返回情况下，数据会优先进入第一个回调方法
 * 在请求错误的情况下，错误会进入第二个回调方法
 */
// axios.interceptors.response.use((response) => {
//     //  统一处理数据，使组件中的请求只获取到需要的业务数据，
//     // 而不需要去关注返回的状态码等与业务无关的数据
//     // console.log('响应拦截器');

//     return response.data;
//  }, (error) => {
//     // 处理错误的响应
//     return Promise.reject(error);
//  }),


/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
axios.adornParams = (params = {}, openDefultParams = true) => {
    let defaults = {
        't': new Date().getTime()
    }
    return openDefultParams ? merge(defaults, params) : params
};

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
axios.gets = (url, params) => {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res);
        }).catch(err => {
            reject(err.data)
        })
    });
};


/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
axios.adornData = (data = {}, openDefultdata = true, contentType = 'json') => {
    
     let defaults = {
         't': new Date().getTime()
     };
    let data1 = openDefultdata ? merge(defaults, data) : data;
    return contentType === 'json' ? JSON.stringify(data1) : qs.stringify(data1);
};

axios.jsonContent = () => {
    let defaults = {
        'headers': { 'Content-Type': 'application/json; charset=utf-8'}
    };
    
    return defaults;
};

//  绑定到 vue 原型中，组件中 ： this.$http -> axios 。

export default axios
Vue.prototype.$http = axios;
